import React from "react";
import { Facebook } from "lucide-react";
import { SOCIAL_LINKS, type SocialLinkId } from "../../data/social";
import { trackSocialClick } from "../../analytics";

function InstagramIcon ({ size = 18 }: { size?: number }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function SocialIcon ({
  id,
  size = 18,
}: {
  id: SocialLinkId;
  size?: number;
}): JSX.Element {
  if (id === "facebook") {
    return <Facebook size={size} aria-hidden="true" />;
  }
  return <InstagramIcon size={size} />;
}

type SocialLinksProps = {
  className?: string;
  linkClassName?: string;
  iconSize?: number;
};

export function SocialLinks ({
  className,
  linkClassName,
  iconSize = 18,
}: SocialLinksProps): JSX.Element {
  return (
    <div className={className}>
      {SOCIAL_LINKS.map((link) => (
        <a
          key={link.id}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.label}
          className={linkClassName}
          onClick={() => {
            trackSocialClick(link.id);
          }}
        >
          <SocialIcon id={link.id} size={iconSize} />
        </a>
      ))}
    </div>
  );
}
